import React, { useState, useEffect } from "react";
import axios from "axios";
import { Corporate_url } from "../../Config/Config";
import "../../styles/Home.css";
import Inbox from "../RecieveMessages/Inbox";


const Home = () => {
  const [userDetails, setUserDetails] = useState(null);
  // Get the current hour
  const currentTime = new Date().getHours();
  const fetchUserDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("user_id");
      const response = await axios.get(
        `${Corporate_url}/api/user-details/${Number(userId)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUserDetails(response.data);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  return (
    <div className=" home mt-5  ">
      <div className="  mt-5" style={{height:"100%"}}>
        <div className=" p-5 mt-3"style={{height:"100%"}}>
          <div className="content-status-inner">
            <div className="hello-head">
              <div className="hello-text">
                <span>
                  Hello,{" "}
                  {userDetails
                    ? `${userDetails.first_name} ${userDetails.last_name}`
                    : "User"}
                  !
                </span>
              </div>
              <div className="wish-text">
                {currentTime < 12 ? (
                  <h5>Good Morning</h5>
                ) : currentTime < 18 ? (
                  <h5>Good Afternoon</h5>
                ) : (
                  <h5>Good Evening</h5>
                )}
              </div>
            </div>
            <div className="inbox-page">
                <Inbox />
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
